export default __webpack_public_path__ + "static/media/Gotham Black Regular.8c419f68.ttf";